__turbopack_context__.v({
  "actions": "status-page-module__5hBNAW__actions",
  "body": "status-page-module__5hBNAW__body",
  "contact": "status-page-module__5hBNAW__contact",
  "document": "status-page-module__5hBNAW__document",
  "documentBody": "status-page-module__5hBNAW__documentBody",
  "eyebrow": "status-page-module__5hBNAW__eyebrow",
  "header": "status-page-module__5hBNAW__header",
  "headerInner": "status-page-module__5hBNAW__headerInner",
  "headline": "status-page-module__5hBNAW__headline",
  "label": "status-page-module__5hBNAW__label",
  "logo": "status-page-module__5hBNAW__logo",
  "logoMark": "status-page-module__5hBNAW__logoMark",
  "main": "status-page-module__5hBNAW__main",
  "mark": "status-page-module__5hBNAW__mark",
  "primary": "status-page-module__5hBNAW__primary",
  "reset": "status-page-module__5hBNAW__reset",
  "root": "status-page-module__5hBNAW__root",
  "secondary": "status-page-module__5hBNAW__secondary",
});
